import { PhysicianSchema } from '@/features/physician-schema/physician-schema';

import Booking from './booking';
import { BookingProps } from './booking.types';

export const OASBooking = ({ rendering }: BookingProps): JSX.Element => {
  if (rendering.fields.notFound) {
    return <></>;
  }

  return (
    <>
      <PhysicianSchema {...rendering?.fields?.physicianData} />
      <Booking rendering={rendering} />
    </>
  );
};
